import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  AddAnalogueModelAreaCommandForm,
  postApiV1AnalogueModelsByIdModelAreas,
  putApiV1AnalogueModelsByIdModelAreasByModelAreaId,
  UpdateAnalogueModelAreaCommandForm,
} from '../api/generated';
import { queryKeys } from './queryKeys';

export const useMutateAreaCoordinates = () => {
  const queryClient = useQueryClient();
  const postAreaCoordinates = useMutation({
    mutationFn: ({
      id,
      requestBody,
    }: {
      id: string;
      requestBody: AddAnalogueModelAreaCommandForm;
    }) => {
      return postApiV1AnalogueModelsByIdModelAreas({
        body: requestBody,
        path: { id: id },
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.analogueModel(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.objectResults(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.variogramResults(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.modelCases(variables.id),
      });
    },
  });

  const putAreaCoordinates = useMutation({
    mutationFn: ({
      id,
      modelAreaId,
      requestBody,
    }: {
      id: string;
      modelAreaId: string;
      requestBody: UpdateAnalogueModelAreaCommandForm;
    }) => {
      return putApiV1AnalogueModelsByIdModelAreasByModelAreaId({
        body: requestBody,
        path: {
          id: id,
          modelAreaId: modelAreaId,
        },
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.analogueModel(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.objectResults(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.variogramResults(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.modelCases(variables.id),
      });
    },
  });

  return { postAreaCoordinates, putAreaCoordinates };
};
